import React from "react";
import PublicHeader from "../components/PublicHeader";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

export default function LegalPage({ kind }) {
  const isPrivacy = kind === "privacy";
  const title = isPrivacy ? "Privacy Policy" : "Terms of Service";
  const updated = "February 2026";
  const seoTitle = isPrivacy
    ? "Privacy Policy | WriterSpark"
    : "Terms of Service | WriterSpark";
  const seoDesc = isPrivacy
    ? "How WriterSpark protects student, parent, and educator data. COPPA-aligned practices, data rights, and contact info."
    : "WriterSpark Terms of Service. Acceptable use, account responsibilities, intellectual property, and contact information.";

  return (
    <div className="min-h-screen bg-slate-50">
      <Seo title={seoTitle} description={seoDesc} path={`/${kind}`} />
      <PublicHeader />
      <section className="max-w-3xl mx-auto px-6 py-16">
        <span className="text-xs uppercase font-bold tracking-widest text-indigo-700">Legal</span>
        <h1 className="mt-3 text-4xl font-bold" style={{fontFamily:'Outfit'}} data-testid={`legal-title-${kind}`}>{title}</h1>
        <p className="text-sm text-slate-500 mt-2">Last updated: {updated}</p>

        {isPrivacy ? (
          <div className="prose prose-slate mt-8 space-y-5 text-slate-700 leading-relaxed">
            <p>WriterSpark ("we", "us") is committed to protecting the privacy of students, parents, and educators who use our platform.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Information we collect</h2>
            <p>We collect account information (name, email, grade level, role) and the content of your writing sessions for the sole purpose of providing personalized feedback and tracking your progress.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>How we use it</h2>
            <p>Your writing is sent to our AI coaching provider only to generate the feedback you requested. We do not sell, rent, or share your data with advertisers.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Children's privacy</h2>
            <p>We follow COPPA-aligned practices. Accounts for users under 13 require a parent or teacher to consent. Parents may request deletion of their child's data at any time.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Your rights</h2>
            <p>You may export, correct, or delete your data at any time by emailing <a href="mailto:info@writersspark.net" className="text-indigo-700 font-semibold">info@writersspark.net</a>.</p>
          </div>
        ) : (
          <div className="prose prose-slate mt-8 space-y-5 text-slate-700 leading-relaxed">
            <p>By using WriterSpark, you agree to these Terms.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Acceptable use</h2>
            <p>WriterSpark is a coaching platform. Use it to learn and practice writing. Do not submit harmful content, attempt to bypass security, or use the service to harass others.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Account security</h2>
            <p>You are responsible for maintaining the confidentiality of your account credentials.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Intellectual property</h2>
            <p>You retain ownership of your writing. You grant us a limited license to process your content solely to provide the coaching service.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Changes</h2>
            <p>We may update these Terms periodically. We will notify users of material changes via email.</p>
            <h2 className="text-xl font-bold pt-4" style={{fontFamily:'Outfit'}}>Contact</h2>
            <p>Questions? Reach us at <a href="mailto:info@writersspark.net" className="text-indigo-700 font-semibold">info@writersspark.net</a>.</p>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
